import { Controller } from "@hotwired/stimulus";
class default_1 extends Controller {
    constructor() {
        super(...arguments);
        this.stream = null;
        this.imageDataUrl = null;
        this.currentFacingMode = "environment";
    }
    toggleStartStopClasses() {
        this.captureControlsTarget.classList.toggle("d-none");
        this.stopButtonTarget.classList.toggle("d-none");
        this.startButtonTarget.classList.toggle("d-none");
        this.videoTarget.classList.toggle("d-none");
        this.switchButtonTarget.classList.toggle("d-none");
    }
    async startCamera() {
        try {
            this.stream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: this.currentFacingMode },
            });
            this.videoTarget.srcObject = this.stream;
            this.videoTarget.play();
            // Show/hide the elements
            this.toggleStartStopClasses();
        }
        catch (error) {
            console.error(error);
        }
    }
    async switchCamera() {
        this.currentFacingMode =
            this.currentFacingMode === "user" ? "environment" : "user";
        await this.stopCamera();
        await this.startCamera();
    }
    async stopCamera() {
        if (this.stream) {
            this.stream.getTracks().forEach((track) => track.stop());
            this.videoTarget.srcObject = null;
            this.stream = null;
        }
        // Show/hide the elements
        this.toggleStartStopClasses();
        this.videoTarget.classList.add("d-none");
        this.photoTarget.classList.add("d-none");
        this.captureControlsTarget.classList.add("d-none");
    }
    async takePicture() {
        const canvas = document.createElement("canvas");
        canvas.width = this.videoTarget.videoWidth;
        canvas.height = this.videoTarget.videoHeight;
        const context = canvas.getContext("2d");
        context?.drawImage(this.videoTarget, 0, 0, canvas.width, canvas.height);
        this.imageDataUrl = canvas.toDataURL("image/png");
        this.photoTarget.src = this.imageDataUrl;
        await this.savePicture();
        await this.stopCamera();
        this.captureControlsTarget.classList.add("d-none");
        this.photoTarget.classList.remove("d-none");
        this.videoTarget.classList.add("d-none");
        this.stopButtonTarget.classList.remove("d-none");
        this.startButtonTarget.classList.add("d-none");
    }
    async savePicture() {
        if (!this.imageDataUrl)
            return console.warn("Nothing to save.");
        const csrfToken = document.querySelector("[name=csrf-token]").content;
        const response = await fetch("/verifs/upload_photo", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": csrfToken,
            },
            body: JSON.stringify({ id: this.idValue, image: this.imageDataUrl }),
        });
        const data = await response.json();
        if (data.redirect_url)
            window.location.href = data.redirect_url;
    }
}
default_1.targets = [
    "photo",
    "video",
    "startButton",
    "stopButton",
    "captureControls",
    "switchButton",
];
default_1.values = { id: Number };
export default default_1;
